import React from 'react';
import {
    Link
} from 'react-router-dom';
import LoadingBar from 'react-top-loading-bar';
import 'antd/dist/antd.css';
import {
    Container,
    styleButton as Button,
    Title,
    Description
} from './style';

class Home extends React.Component {
    state = {
        loadingBarProgress: Math.random() * 100
    };

    complete = () => {
        this.setState({ loadingBarProgress: 100 });
    };

    onLoaderFinished = () => {
        this.setState({ loadingBarProgress: 0 });
    };

    componentDidMount() {
        this.complete();
    }

    render() {
        return (
            <Container>
                <LoadingBar
                    progress={this.state.loadingBarProgress}
                    height={3}
                    color='#fff'
                    onLoaderFinished={() => this.onLoaderFinished()}
                />

                <Title> {"{"} nightbot.dev {"}"} </Title>
                <Description> &middot; Chatbot Developer &middot;</Description>
                <Link to={"/about"}><Button block>About</Button></Link>
                <a href="https://medium.com/@dkhd" target="_blank" rel="noopener noreferrer"><Button block>Articles</Button></a>
                <Description>&nbsp;</Description>
                <Description>Try Me!</Description>
                <a href="https://winterly.app?utm_source=nightbot.dev" target="_blank" rel="noopener noreferrer"><Button block>Winterly</Button></a>
                <Link to="/online-store-chatbot"><Button block>Online Store Chatbot</Button></Link>
                <Link to="/dialogflow-chatbot"><Button block>Dialogflow Chatbot</Button></Link>
                <Link to="/covid19"><Button block>Covid-19 Stats</Button></Link>
                <Description>&nbsp;</Description>
                <Link to={"/faq"}><Button block>FAQs</Button></Link>
            </Container>
        )
    }
}

export default Home;